import { render, staticRenderFns } from "./OpenQuestionWithAdditionals.vue?vue&type=template&id=22c08063&"
import script from "./OpenQuestionWithAdditionals.vue?vue&type=script&lang=js&"
export * from "./OpenQuestionWithAdditionals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports